import React from 'react';
import type { AgentChatScope } from '../../services/api';

// PHA-549: small chip in the chat header that mirrors what SmartHub shows —
// makes the agent's current focus discoverable so the user understands why an
// answer is patient-scoped vs clinic-scoped.
const ChatScopeBadge: React.FC<{ scope: AgentChatScope | null }> = ({ scope }) => {
  if (!scope) return null;

  const isPatient = scope.kind === 'patient';
  const label = isPatient
    ? scope.patientName || scope.patientId
    : scope.orgName
      ? `All patients · ${scope.orgName}`
      : 'All patients';

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-start',
        padding: '6px 24px 0',
        flexShrink: 0,
      }}
    >
      <span
        title={
          isPatient
            ? `The agent is focused on ${label}.`
            : 'The agent is focused on your full patient list.'
        }
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 6,
          padding: '3px 10px',
          borderRadius: 999,
          background: isPatient ? '#eef2ff' : '#ecfdf5',
          color: isPatient ? '#3730a3' : '#065f46',
          fontSize: 12,
          fontWeight: 500,
          maxWidth: '100%',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        <span style={{ opacity: 0.7 }}>Asking about</span>
        <span style={{ fontWeight: 600 }}>{label}</span>
      </span>
    </div>
  );
};

export default ChatScopeBadge;
